module.exports = "<div class=\"container\">\r\n  <h2>Organizers</h2>\r\n  <ul>\r\n    <li><a href=\"http://www.staff.amu.edu.pl/~stefbar/\">Stefan Barańczuk</a> UAM Poznań</li>\r\n    <li><a>Dorota Blinkiewicz</a> UAM Poznań</li>\r\n    <li><a>Piotr Rzonsowski</a> Cognitran</li>\r\n  </ul>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/rzonsol/WebstormProjects/banaszak60/src/app/main/organizers/organizers.component.html
// module id = ../../../../../src/app/main/organizers/organizers.component.html
// module chunks = main